import axios, { AxiosError } from "axios";

/**
 * @brief This defines our external dependency.  Any network requests meet these
 * signature.
 */

export interface AjaxResponse<T> {
  data: T;
}
export interface Ajax {
  get: <T>(url: string) => Promise<AjaxResponse<T>>;
  post: <T>(url: string, data: any) => Promise<AjaxResponse<T>>;
  delete: <T>(url: string) => Promise<AjaxResponse<T>>;
}
export const ajax: Ajax = axios;

export type AjaxError = AxiosError;

export const login = (username: string, password: string) => {
  axios.defaults.headers.common["Authorization"] =
    "Basic " + btoa(username + ":" + password);
};

export default ajax;
